module.exports = __webpack_public_path__ + "img/men-icon.f709e2df.png";